import React from 'react';
import { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Grid, CardHeader } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import CountUp from 'react-countup';
function SetCard({ detailCard }) {
  const isXsScreen = useMediaQuery('(max-width:600px)'); // เช็คหน้าจอขนาด xs
  return (
    <Grid item xs={6} md={6} lg={3}>
      <Card
        variant="outlined"
        sx={{
          backgroundColor: '#F5F6FA',
          border: 'none',
          borderRadius: '10px',
          borderColor:"#5cc1a9",
          borderStyle:"solid"
        }}
      >
        <CardContent>
          {isXsScreen ? (
            <Typography
              variant="h7"
              sx={{
                color: detailCard.color,
                textAlign: 'center',
                fontWeight: '700',
              }}
            >
              {detailCard.title}
            </Typography>
          ) : (
            <Typography
              variant="h5"
              sx={{
                color: detailCard.color,
                textAlign: 'center',
                fontWeight: '500',
              }}
            >
              {detailCard.title}
            </Typography>
          )}
          {isXsScreen ? (
            <div>
              <div style={{ textAlign: 'right' }}>
                <Typography variant="h7">
                  <CountUp end={detailCard.value} /> รายการ
                </Typography>
              </div>
              <div style={{ textAlign: 'right' }}>
                <Typography variant="h7">
                  <CountUp end={detailCard.money} /> บาท
                </Typography>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ textAlign: 'right' }}>
                <Typography variant="h5">
                  <CountUp end={detailCard.value} /> รายการ
                </Typography>
              </div>
              <div style={{ textAlign: 'right' }}>
                <Typography variant="h5">
                  {detailCard.money == '' ? '0': <CountUp end={detailCard.money} decimals={2} />}
                  {detailCard.money == '' ? ' บาท': " บาท"}
                </Typography>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

function CardOverView({ data }) {
  if (!data || !data[0]) {
    return <div>Loading...</div>;
  }
  const detailCard = data;
  return (
    <div>
      <Grid container spacing={2}>
        {detailCard.map((item, index) => (
          <SetCard key={index} detailCard={item}></SetCard>
        ))}
      </Grid>
    </div>
  );
}

export default CardOverView;